import { render } from "./AccordionToggle.vue?vue&type=template&id=76d669fa&scoped=true"
import script from "./AccordionToggle.vue?vue&type=script&lang=js"
export * from "./AccordionToggle.vue?vue&type=script&lang=js"

import "./AccordionToggle.vue?vue&type=style&index=0&id=76d669fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d669fa"]])

export default __exports__